import { REHYDRATE } from 'redux-persist';
import { LOGGED_OUT } from 'actions/types';
import { CREDIT_SCORE_CLEAR_REGISTRATION_COOLDOWN, CREDIT_SCORE_GET_REGISTRATION_STATUS_SUCCESS, CREDIT_SCORE_GET_SCORE_SUCCESS, CREDIT_SCORE_MARK_ANIMATION_CONSUMED, CREDIT_SCORE_RESET_DATA, CREDIT_SCORE_SET_REGISTRATION_COOLDOWN, CREDIT_SCORE_START_REGISTRATION_SUCCESS, } from '../actions/types';
export const initialState = {
    status: 'UNKNOWN_REGISTRATION_STATUS',
    data: undefined,
    bands: undefined,
    registerRetryCooldown: undefined,
    lastSeenScore: null,
};
const creditScoreReducer = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const persisted = action.payload?.creditScore;
            if (persisted) {
                return {
                    ...initialState,
                    ...persisted,
                    // CreditScoreData after first ship are absent in data persisted
                    // by older app versions, so coalesce them here.
                    data: persisted.data
                        ? {
                            ...persisted.data,
                            lastChange: persisted.data.lastChange ?? null,
                            lastChangeDate: persisted.data.lastChangeDate ?? null,
                        }
                        : undefined,
                };
            }
            return state;
        }
        case LOGGED_OUT: {
            return initialState;
        }
        case CREDIT_SCORE_GET_SCORE_SUCCESS: {
            const { status, agency, band, nextUpdateDate, scoreDate, score, change, lastChange, lastChangeDate, minScore, maxScore, bands, } = action.payload;
            const hasData = agency !== null &&
                band !== null &&
                nextUpdateDate !== null &&
                scoreDate !== null &&
                score !== null &&
                minScore !== null &&
                maxScore !== null;
            return {
                ...state,
                status,
                data: hasData
                    ? {
                        agency,
                        band,
                        nextUpdateDate,
                        scoreDate,
                        score,
                        change,
                        lastChange: lastChange ?? null,
                        lastChangeDate: lastChangeDate ?? null,
                        minScore,
                        maxScore,
                    }
                    : undefined,
                bands: bands.length > 0 ? bands : undefined,
            };
        }
        case CREDIT_SCORE_GET_REGISTRATION_STATUS_SUCCESS: {
            return {
                ...state,
                status: action.payload.status,
            };
        }
        case CREDIT_SCORE_START_REGISTRATION_SUCCESS: {
            return {
                ...state,
                status: action.payload.status,
                registerRetryCooldown: undefined,
            };
        }
        case CREDIT_SCORE_RESET_DATA: {
            return {
                ...initialState,
                status: state.status,
                registerRetryCooldown: state.registerRetryCooldown,
            };
        }
        case CREDIT_SCORE_SET_REGISTRATION_COOLDOWN: {
            return {
                ...state,
                registerRetryCooldown: action.payload,
            };
        }
        case CREDIT_SCORE_CLEAR_REGISTRATION_COOLDOWN: {
            return {
                ...state,
                registerRetryCooldown: undefined,
            };
        }
        case CREDIT_SCORE_MARK_ANIMATION_CONSUMED: {
            return {
                ...state,
                lastSeenScore: state.data?.score ?? state.lastSeenScore,
            };
        }
        default:
            return state;
    }
};
export default creditScoreReducer;
